import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import ProductDefinitionEditor from "./ProductDefinitionEditor";
import { getProduct, getProductByCode } from "./services/MrcaiAPI";

// The editor PUTs the whole product back, so load the full record by id
export const fetchProduct = async (code) => {
  const product = await getProductByCode(code);
  if (!product) {
    throw new Error(`Failed to fetch product for code: ${code}`);
  }
  return getProduct(product._id);
};

const ProductDefinitionEditorPage = () => {
  const { productCode } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [product, setProduct] = useState(null);
  const [isNew, setIsNew] = useState(state?.isNew || false);

  useEffect(() => {
    if (!isNew) {
      fetchProduct(productCode).then(setProduct);
    } else {
      setProduct({
        _id: null,
        code: productCode,
        name: "",
        clockId: "",
        contractSchema: { id: "", version: "" },
        description: "",
        routing: {
          signalsEndpoint: "",
          triggersEndpoint: "",
          eventsEndpoint: "",
          productEndpoint: "",
          contractsEndpoint: "",
          workflowEndpoint: "",
        },
        signalRegister: [],
        triggerRegister: [],
        eventRegister: [],
        productRegister: [],
        workflowRegister: [],
        roleDefinitions: [],
        activityPatternDefinitions: [],
        createdDate: new Date().toISOString(),
        productTemplates: [],
        controls: [],
      });
    }
  }, [productCode, isNew]);

  if (!product) return <Spinner />;

  const handleClose = () => {
    // Change this to window.history.back()
    window.history.back();
  };

  return (
    <ProductDefinitionEditor
      product={product}
      isNew={isNew}
      onSave={(updatedProduct, wasNew) => {
        setProduct(updatedProduct);
        if (wasNew) {
          setIsNew(false);
          navigate(`/poc/product/${updatedProduct.code}/edit`, {
            state: { isNew: false },
          });
        }
      }}
      onBack={handleClose}
    />
  );
};

export default ProductDefinitionEditorPage;
